import React from "react";
import {
  Switch,
  Route,
  Redirect,
  BrowserRouter as Router,
} from "react-router-dom";
import { LocaleProvider, Modal } from "antd";
import { connect } from "react-redux";
import config from "config/routes";
import PropTypes from "prop-types";
import Spin from "components/common/Spin";
import Layout from "components/layout";
import NotFound from "routes/NotFound";
import faIR from "antd/lib/locale-provider/fa_IR";
import enUS from "antd/lib/locale-provider/en_US";
import {
  showModules,
  showTypes,
  showNotification,
  readNotification,
  showCompany,
  showGraph,
} from "routes/General/Module";
import {
  verifyAuthentication,
  indexPermissions,
  showCurrentUser,
  uiPermission,
} from "routes/Auth/Module";
import jMoment from "moment-jalaali";
import Notification from "components/common/Notification";
import configApp from "config/app";

jMoment.locale(app.lang.locale);

jMoment.loadPersian({ usePersianDigits: false, dialect: "persian-modern" });

@connect(
  (state) => ({
    authenticated: state.Auth.authenticated,
    notifications: state.General.notifications,
    permissions: state.Auth.currentPermissions,
  }),
  {
    verifyAuthentication,
    indexPermissions,
    showCurrentUser,
    showCompany,
    showGraph,
    showNotification,
    readNotification,
    showModules,
    showTypes,
  }
)
@autobind
/**
 *
 */
export default class Routes extends React.PureComponent {
  static propTypes = {
    authenticated: PropTypes.bool,
    permissions: PropTypes.array,
    verifyAuthentication: PropTypes.func,
    indexPermissions: PropTypes.func,
    showCurrentUser: PropTypes.func,
    showCompany: PropTypes.func,
    showNotification: PropTypes.func,
    readNotification: PropTypes.func,
    showModules: PropTypes.func,
    showTypes: PropTypes.func,
    notifications: PropTypes.array,
  };
  static defaultProps = {
    notifications: [],
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      render: true,
      initializing: "برنامه",
      permissions: [],
    };
  }

  _notificationOnClose = (id) => {
    const { readNotification } = this.props;
    readNotification(id);
  };

  /**
   *
   */
  componentDidMount() {
    const {
      authenticated,
      verifyAuthentication,
      indexPermissions,
      showCurrentUser,
      showCompany,
      showGraph,
      showModules,
      showTypes,
    } = this.props;

    if (authenticated) {
      // indexPermissions();
      this.setState({ render: false }, () => {
        showCurrentUser({
          includes: ["profile.company", "positions", "taUserInfo", "roles"],
        });
        // showCurrentUser({includes: ['profile.company', 'taUserInfo']});
        showCompany();
        showGraph();
        // this._getNotification(this.props);
        showModules();
        showTypes(
          {
            includes: [
              // "children.children.children"
              "form.fields",
              "rule.form.fields",
            ],
            // filterGroups: [
            //   {
            //     filters: [
            //       {
            //         key: "type_id",
            //         value: null,
            //         operator: "eq",
            //       },
            //     ],
            //   }],
          },
          () => {
            indexPermissions(() => {
              this.setState({ render: true });
            });
          }
        );
      });
    } else if (authenticated === null) {
      verifyAuthentication();
    }

    this.readUiPermissions();
  }

  readUiPermissions = () => {
    this.readTextFile("permission.json", (err, res) => {
      if (res && !err) {
        this.getReportBuilderPermission(res);
      } else if (!res && err) {
        this.getReportBuilderPermission();
      }
    });
  };

  getReportBuilderPermission = (otherPermissions = []) => {
    this.readTextFile("report_builder.json", (err, res) => {
      if (res && res.length > 0 && !err) {
        otherPermissions.push(...res);
      }
      app.dispatch(uiPermission(otherPermissions));
    });
  };

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    // const ssssss = { type: 10 };
    if (np.authenticated && this.props.authenticated !== np.authenticated) {
      this.setState({ render: false }, () => {
        this.setState({ initializing: "کاربری" }, () => {
          np.showCurrentUser(
            { includes: ["profile.company", "positions", "taInfo", "roles"] },
            () => {
              this.setState({ initializing: "سامانه" }, () => {
                np.showCompany({}, () => {
                  this.setState({ initializing: "کنسول ها" }, () => {
                    np.showModules({}, () => {
                      this.setState({ initializing: "زیر ساخت" }, () => {
                        np.showTypes(
                          {
                            includes: [
                              // "children.children.children",
                              "form.fields",
                              "rule.form.fields",
                            ],
                            // filterGroups: [
                            //   {
                            //     filters: [
                            //       {
                            //         key: "type_id",
                            //         value: null,
                            //         operator: "eq",
                            //       },
                            //     ],
                            //   }],
                          },
                          () => {
                            this.setState({ initializing: "دسترس ها" }, () => {
                              np.indexPermissions(() => {
                                this.setState({
                                  render: true,
                                  initializing: "",
                                });
                                this._getNotification(np);
                              });
                            });
                            // np.showGraph(ssssss, ssssss);
                            // np.showGraph(ssssss, ssssss);
                          }
                        );
                      });
                    });
                  });
                });
              });
            }
          );
        });

        this.readUiPermissions();
      });
    }

    if (np.notifications && this.props.notifications !== np.notifications) {
      const notif = np.notifications.filter(
        this._comparer(this.props.notifications)
      );
      this._notifications(notif);
    }

    if (!np.permissions.equals(this.state.permissions)) {
      this.setState({ permissions: np.permissions });

      this.readUiPermissions();
      // this.setState({ render: false }, () => {
      //   this.setState({ render: true }, () => {
      //   });
      // });
    }
    if (!app._.isEqual(np.notifications, this.props.notifications)) {
      // console.log(np.notifications);
      const notif = np.notifications.filter(
        this._comparer(this.props.notifications)
      );
      notif &&
        notif.map((item, index) => {
          setTimeout(
            Notification.render,
            index * 2000,
            item,
            this._notificationOnClose
          );
        });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!app._.isEqual(this.state, nextState)) {
      return true;
    }
    return false;
  }

  _comparer(otherArray) {
    return (current) =>
      otherArray.filter((other) => other.id === current.id).length === 0;
  }

  readTextFile(file, cb = () => {}) {
    let rawFile = new XMLHttpRequest();
    rawFile.open("GET", `${window.location.origin}/${file}`, false);
    rawFile.onreadystatechange = function () {
      if (rawFile.readyState === 4) {
        if (rawFile.status === 200 || rawFile.status === 0) {
          let permissionData = rawFile.responseText;
          try {
            permissionData = JSON.parse(permissionData);
            permissionData = (permissionData && permissionData.data) || [];
          } catch (e) {
            permissionData = [];
          }
          cb(false, permissionData);
        } else {
          cb(true, false);
        }
      }
    };
    rawFile.send(null);
  }

  _getNotification(props) {
    let _state = Object.assign(
      {},
      {
        type: "notification",
        duration: 0,
        loop: 10,
        icon: "yes",
        active: "yes",
        placement: "bottomLeft",
      },
      app.local.load("notification")
    );

    if (_state.active === "yes") {
      props.showNotification(
        { notifications: [] },
        {
          filterGroups: [
            {
              filters: [
                {
                  key: "read",
                  value: null,
                  operator: "eq",
                },
              ],
            },
          ],
        },
        (err) => {
          if (!err) {
            let notificationInterval =
              parseInt(
                `0${_state.loop && _state.loop !== "" ? _state.loop : 10}`
              ) * 1000;

            setTimeout(this._getNotification, notificationInterval, props);
          }
        }
      );
    } else {
      setTimeout(this._getNotification, 3000, props);
    }
  }

  /**
   *
   * @param {String} msg
   * @private
   */
  _notice(msg = "") {
    let _msg = msg.replace("\r\n", "\n");
    _msg = _msg.replace("\\r\\n", "\n");
    _msg = _msg.replace("\\", "\n");
    Modal.error({
      title: app.translate("routes.home.requests.Notice"),
      content: _msg,
    });
  }

  /**
   *
   * @param {Array} notifications
   * @private
   */
  _notifications(notifications) {
    if (notifications && notifications[0]) {
      notifications.map((item) => {
        if (item.type === "notice") {
          this._notice(item.detail);
        }
      });
    }
  }
  /**
   *
   * @param {Object} route
   * @param {String} path
   * @return {Array}
   * @private
   */
  _getRoutes(route, path) {
    if (route.path) {
      path = `${path}/${route.path}`;
    }

    return [
      <Route key={path} exact path={path} component={route.component} />,
    ].concat(route.routes ? this._get(route.routes, path) : []);
  }

  /**
   *
   * @param {Object} route
   * @return {Array}
   * @private
   */
  _getRedirects(route) {
    return [
      <Route
        key={route.path}
        exact={route.exact}
        path={route.path}
        render={() => <Redirect to={route.routes[0].path} />}
      />,
    ];
  }
  /**
   *
   * @param {Object[]} routes
   * @param {String} [path=""]
   * @return {Array}
   * @private
   */
  _get(routes, path = "") {
    const _routes = [];

    routes.forEach((route) => {
      switch (route.type) {
        case "route":
          // Check if this route has isNotAdmin permission for non-admin users
          let _checkIsNotAdmin = -1;
          if (route.permissions) {
            _checkIsNotAdmin = route.permissions.findIndex(
              (item) => item === "isNotAdmin"
            );
          }
          
          // Add route if:
          // 1. User has permission through normal app.haveMenu check OR
          // 2. Route has isNotAdmin permission AND user is not admin
          if (route.permissions && 
             (app.haveMenu(route.permissions) || 
              (_checkIsNotAdmin !== -1 && !app.isAdmin()))) {
            _routes.push(...this._getRoutes(route, path));
          } else {
            route.priority = 550000000;
          }
          break;
        case "redirect":
          _routes.push(...this._getRedirects(route));
          break;
      }
    });

    return _routes;
  }

  /**
   *
   * @param {Object[]} routes
   * @return {Array}
   * @private
   */
  _getAuth(routes) {
    const _routes = routes.map((route, index) => (
      <Route
        key={index + 1}
        exact
        path={`/${route.path}`}
        component={route.component}
      />
    ));

    _routes.push(
      <Route
        key={0}
        render={() => (
          <Redirect
            to={{
              pathname: "/login",
              state: { referrer: window.location.pathname.slice(1) },
            }}
          />
        )}
      />
    );

    return _routes;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const render = this.state.render;
    const authenticated = this.props.authenticated;

    return (
      <Router>
        <LocaleProvider locale={app.lang.locale === "fa" ? faIR : enUS}>
          {
            //  || (authenticated&& permissions.length === 0)
            authenticated === null || !this.state.render ? (
              <Spin
                size="large"
                tip={` راه اندازی ${this.state.initializing}`}
                spinning
                style={{
                  position: "absolute",
                  top: "calc(50% - 28px)",
                  left: `calc(50% - ${66.77 / 2}px)`,
                }}
              />
            ) : authenticated ? (
              <Layout>
                <Switch>
                  {this._get(config.routes.home)}
                  <Route component={NotFound} />
                </Switch>
              </Layout>
            ) : (
              <Switch>{this._getAuth(config.routes.auth)}</Switch>
            )
          }
        </LocaleProvider>
      </Router>
    );
  }
}
